import React, {Component} from "react";

export class Logo extends Component {
    render() {
        return <span className="text-black font-bold">
            Whoops.io <sup className="bg-pink text-white rounded-full p-1">Beta</sup>
        </span>;
    }
}